import PythonVersioned from "./python-versioned.mdx";
import PythonVersionless from "./python-versionless.mdx";

{props.usesVersionlessApi ? (
  <PythonVersionless {...props} />
 ) : (
  <PythonVersioned {...props} />
 )}
